import { match, matchPath } from 'react-router'
import { createSelector } from 'reselect'
import { BudgetMatchParams, budgetRouteProps } from 'src/navigation/routeProps'
import { RootState } from 'src/redux/createRootReducer'
import {
  selectCreditCardListModelsFromState,
  selectCreditCardPermissionsModelsFromState,
  selectCreditCardStatisticsActiveBudgetCountFromState,
  selectCreditCardStatisticsActiveVcnCountFromState,
  selectCreditCardStatisticsBudgetCountFromState,
  selectCreditCardStatisticsVcnCountFromState,
} from 'src/redux/selectors/data/creditCards.selectors'
import { selectUserListModelsFromState } from 'src/redux/selectors/data/users.selectors'
import { selectCalculatedBackgroundLocation } from 'src/redux/selectors/router.selectors'

export const selectCreditCardIdFromRoute = createSelector(
  [selectCalculatedBackgroundLocation],
  (backgroundLocation) => {
    const mtch = matchPath<BudgetMatchParams>(
      backgroundLocation.pathname,
      budgetRouteProps,
    ) as match<BudgetMatchParams>
    return mtch?.params.id
  },
)

export const selectCreditCard = createSelector(
  [selectCreditCardListModelsFromState, selectCreditCardIdFromRoute],
  (creditCards, creditCardId) => {
    return creditCards[creditCardId] !== undefined
      ? creditCards[creditCardId]
      : undefined
  },
)

export const selectCreditCardPermissions = createSelector(
  [selectCreditCardPermissionsModelsFromState, selectCreditCardIdFromRoute],
  (creditCardPermissions, creditCardId) => {
    return creditCardPermissions[creditCardId] !== undefined
      ? creditCardPermissions[creditCardId]
      : undefined
  },
)

export const selectCreditCardUser = createSelector(
  [selectCreditCard, selectUserListModelsFromState],
  (creditCard, users) =>
    creditCard !== undefined ? users[creditCard?.userId] : undefined,
)

export const selectFetchingCreditCard = (
  state: RootState,
): boolean | undefined => state.app.account.fetchingCreditCard

export const selectCreditCardStatisticsActiveVcnCount = createSelector(
  [
    selectCreditCardStatisticsActiveVcnCountFromState,
    selectCreditCardIdFromRoute,
  ],
  (activeVcnCount, creditCardId) => {
    return activeVcnCount[creditCardId] !== undefined
      ? activeVcnCount[creditCardId]
      : undefined
  },
)

export const selectCreditCardStatisticsVcnCount = createSelector(
  [selectCreditCardStatisticsVcnCountFromState, selectCreditCardIdFromRoute],
  (vcnCount, creditCardId) => {
    return vcnCount[creditCardId] !== undefined
      ? vcnCount[creditCardId]
      : undefined
  },
)

export const selectCreditCardStatisticsActiveBudgetCount = createSelector(
  [
    selectCreditCardStatisticsActiveBudgetCountFromState,
    selectCreditCardIdFromRoute,
  ],
  (activeBudgetCount, creditCardId) => {
    return activeBudgetCount[creditCardId] !== undefined
      ? activeBudgetCount[creditCardId]
      : undefined
  },
)

export const selectCreditCardStatisticsBudgetCount = createSelector(
  [selectCreditCardStatisticsBudgetCountFromState, selectCreditCardIdFromRoute],
  (budgetCount, creditCardId) => {
    return budgetCount[creditCardId] !== undefined
      ? budgetCount[creditCardId]
      : undefined
  },
)
